import { CONFIG } from '../../../config'
import { getUsuarioInfo } from '../../localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/picking`
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

// Área de Separação
export const urlPostPutAreaSeparacao = `${BASE_URL}/area`

export const urlPostMultipleAreaSeparacao = `${BASE_URL}/generate-areas`

export function urlGetAreasSeparacao(tpId) {
  return `${BASE_URL}/areas/${tpId}`
}

export function urlGetTagAreas(params) {
  return `${BASE_URL}/tag-areas?areas_id=${params}&t=${localStorage.getItem('t')}`
}

// Equipes de Separação
export const urlPostPutEquipeSeparacao = `${BASE_URL}/team`

export function urlGetEquipesSeparacao(tpId) {
  return `${BASE_URL}/teams/${tpId}`
}

// Picking
export const urlPostPutPicking = `${BASE_URL}/pick`

export function urlGetPickings(tp_id, picking_status, style, pInicial, pFinal) {
  return `${BASE_URL}/picks?tp_id=${tp_id}&picking_status=${picking_status}&style=${style}&pInicial=${pInicial}&pFinal=${pFinal}`
}

export function urlGetPickingsByNF(tp_id, nf, pInicial, pFinal, company, style) {
  if (pInicial && pFinal) {
    pInicial = `${parseToMysqlFormat(new Date(pInicial))} 00:00:00`
    pFinal = `${parseToMysqlFormat(new Date(pFinal))} 23:59:59`
    return `${BASE_URL}/picks-by-nf/${tp_id}/${nf}?dataInicio=${pInicial}&dataFim=${pFinal}&company=${company}&style=${style}`
  }
  return `${BASE_URL}/picks-by-nf/${tp_id}/${nf}?company=${company}&style=${style}`
}

export function urlGetHistoricoLeituraPeriodoLote(tp_id, company_id, pInicial, pFinal) {
  if (pInicial && pFinal) {
    pInicial = `${parseToMysqlFormat(new Date(pInicial))} 00:00:00`
    pFinal = `${parseToMysqlFormat(new Date(pFinal))} 23:59:59`
  }

  return `${BASE_URL}/historico-leitura-periodo-lote/${tp_id}/${company_id}?dataInicio=${pInicial}&dataFim=${pFinal}`
}

export function urlGetPickingById(picking_id) {
  return `${BASE_URL}/pick/${picking_id}`
}

export function urlGetDeliveriesForPickings(picking_id, periodoInicial, periodoFinal, statusIds) {
  const paramParts = []
  if (periodoInicial && periodoFinal) {
    paramParts.push(`dataInicio=${periodoInicial}&dataFim=${periodoFinal}`)
  }
  if (statusIds && statusIds.length > 0) {
    paramParts.push(`statusIds=${statusIds.join(',')}`)
  }
  const queryString = paramParts.join('&')
  return `${BASE_URL}/deliveries/${picking_id}${queryString ? '?' + queryString : ''}`
}

export function urlGetDeliveriesProductsForPickings(picking_id) {
  return `${BASE_URL}/deliveries-products/${picking_id}`
}

export function urlPostDeliveriesAssocPickings(picking_id) {
  return `${BASE_URL}/assoc-delivery/${picking_id}`
}

export function urlGetExportarPicking(picking_id) {
  return `${BASE_URL}/exportar-picking/${picking_id}`
}

export function urlGetCargaPendenteParaPicking(tp_id) {
  return `${BASE_URL}/cargas-pendentes-para-picking/${tp_id}`
}

export function urlGetDeliveriesByCicloForPicking(tp_id, cycle_id, step) {
  return `${BASE_URL}/deliveries-by-ciclo-for-picking/${tp_id}/${cycle_id}/${step}`
}

export function urlGetAssocDeliveryAreaTeam(picking_id) {
  return `${BASE_URL}/assoc-deliveries-areas/${picking_id}`
}

export function urlGetAssocAreaTeam(picking_id) {
  return `${BASE_URL}/assoc-areas-teams/${picking_id}`
}

export function urlDeletePicking(picking_id) {
  return `${BASE_URL}/pick/${picking_id}`
}

export function urlGetHistoricoDeLeitura(picking_id) {
  return `${BASE_URL}/historico-de-leitura/${picking_id}`
}

export function urlFinalizarAreaSeparacao() {
  return `${BASE_URL}/historico-de-leitura/finalizar-area-separacao`
}

export function urlGetDeliveriesAssociadasBip(picking_id, product_code, area_nome) {
  return `${BASE_URL}/deliveries-associadas-bip/${picking_id}/${encodeURIComponent(
    product_code,
  )}/${encodeURIComponent(area_nome)}`
}

// Associação Entrega x Área de Separação
export const urlPostAssocDeliveryArea = `${BASE_URL}/assoc-areas`
export const urlPostAssocDeliveryAreaReconferencia = `${BASE_URL}/assoc-areas-reconferencia`

export function urlPostImportacaoAssocAreaExcel(picking_id, tipoArquivoId) {
  return `${BASE_URL}/assoc-areas-excel/${picking_id}/${tipoArquivoId}`
}
export function urlPostImportacaoAssocAreaExcelTipoArquivo7(picking_id, tipoArquivoId) {
  return `${BASE_URL}/assoc-areas-excel-tipo-7/${picking_id}/${tipoArquivoId}`
}

export function urlPlacasPrevistaCarregamentoByPickingId(picking_id) {
  return `${BASE_URL}/assoc-areas-placa-prevista-carregamento/${picking_id}`
}

export function urlAssocAreasAhPartirOrdemCarregamento(
  addBadgeToAreaNickname,
  addInfoComplementarToAreaNickname,
) {
  return `${BASE_URL}/assoc-areas-a-partir-ordem-carregamento?addBadgeToAreaNickname=${addBadgeToAreaNickname}&addInfoComplementarToAreaNickname=${addInfoComplementarToAreaNickname}`
}

// Associação Entrega x Equipe de Separação
export function urlPostAssocAreaEquipe(picking_id, pickingteam_id) {
  return `${BASE_URL}/assoc-teams/${picking_id}/${pickingteam_id}`
}

// Alternar Any Checkers para Área
export function urlPutAnyCheckersArea(picking_id, pickingarea_id) {
  return `${BASE_URL}/any-checkers-area/${picking_id}/${pickingarea_id}`
}

// Alternar Any Checkers para todo o Picking
export function urlPutAnyCheckersPicking(picking_id) {
  return `${BASE_URL}/any-checkers-picking/${picking_id}`
}

// Alterar o Status do Picking para Pronto para Download
export function urlPostAterarStatusParaProntoParaDownload(picking_id) {
  return `${BASE_URL}/preparation-to-download/${picking_id}`
}

export const urlPostPutMissingReasons = `${BASE_URL}/missing-reason`

export function urlGetMissingReasons(company_id) {
  return `${BASE_URL}/missing-reasons/${company_id}`
}

export const urlPostPutOcorrencias = `${BASE_URL}/ocorrencia`

export function urlGetOcorrencias(company_id) {
  return `${BASE_URL}/ocorrencias/${company_id}`
}

export const urlPostImportOcorrencias = `${BASE_URL}/ocorrencias/importacao`

export function urlGetResumoSeparacaoInfo(picking_id) {
  return `${BASE_URL}/resumo-separacao-info/${picking_id}`
}

export function urlGetResumoSeparacaoManualInfo(picking_id) {
  return `${BASE_URL}/resumo-separacao-manual-info/${picking_id}`
}

export const urlPostAssocFaltaOcorrencia = `${BASE_URL}/assoc-missing-product-with-reasons`

export const urlPostDesdobrarFalta = `${BASE_URL}/desdobrar-falta`

export const urlPutMissingProductSeparacaoAdjustment = `${BASE_URL}/missing-product-separacao-adjustment`

export const urlPutLeftoverProductSeparacaoAdjustment = `${BASE_URL}/leftover-product-separacao-adjustment`

export function urlPostAssocSobraOcorrencia(selectedPicking) {
  return `${BASE_URL}/assoc-leftover-product-with-reasons/${selectedPicking}`
}

export function urlPostFaltasSeparacaoManual(picking_id) {
  return `${BASE_URL}/missing-product/${picking_id}`
}

export function urlPostSobrasSeparacaoManual(picking_id) {
  return `${BASE_URL}/left-overs-product/${picking_id}`
}

export function urlPostEmitirResumo(picking_id) {
  const { id: user_id } = getUsuarioInfo()
  return `${BASE_URL}/finalizar-resumo-separcao/${picking_id}/${user_id}`
}

export function urlGetImprimirEmitirResumo(picking_id, company_id = null) {
  //Get Token from localstorage
  const token = localStorage.getItem('t')
  if (company_id === 35) {
    // Citro Suco !! - Futuro associar o Tipo de Resumo de Separação com a Empresa (company)
    return `${BASE_URL}/report-resumo-separacao-citro-suco/${picking_id}?t=${token}`
  } else {
    return `${BASE_URL}/report-resumo-separcao/${picking_id}?t=${token}`
  }
}

export function urlGetImprimirEmitirResumoFaltasPorArea(picking_id) {
  const token = localStorage.getItem('t')
  return `${BASE_URL}/report-resumo-separacao-faltas-por-area/${picking_id}?t=${token}`
}

// ***** Tag Pallet *****
export function urlQtePalletPorArea(picking_id) {
  return `${BASE_URL}/qte-pallet-area/${picking_id}`
}

export function urlReportEtiquetaIdentificadorVolumes(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-etiqueta-identificador-volumes/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlValidacaoEtiquetaIdentificadorVolumes(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `?area_ids=${area_ids.join(',')}` : ''
  return `${BASE_URL}/etiqueta-identificador-volumes/validacao/${picking_id}${areaParam}`
}

export function urlCalcularQtePalletPorArea(picking_id) {
  return `${BASE_URL}/calcular-qte-pallet-area/${picking_id}`
}

export function urlCalcularQtePalletPorAreaMetrica(picking_id) {
  return `${BASE_URL}/calcular-qte-pallet-area-metrica/${picking_id}`
}

export function urlReportTagPallet(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-qte-pallet-area/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagLoteDeCarregamento(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-lote-carregamento/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagParaPickingPorProduto(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-por-produto/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagParaPickingPorGrupo(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-por-grupo/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagParaPickingPorRota(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-por-rota/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagSimplificado(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-simplificado/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingCliente07(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-cliente/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingCidades08(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-cidades/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingClienteCodigoBarras(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-cliente-codigo-barras/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingClienteCodigoBarrasSingle(pallet_id) {
  return `${BASE_URL}/report-tag-picking-cliente-codigo-barras-single/${pallet_id}?t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingClienteSimplificado10(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-cliente-simplificado/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingGrupoProdutoCodigoBarras12(picking_id, area_ids) {
  const areaParam = area_ids && area_ids.length > 0 ? `area_ids=${area_ids.join(',')}&` : ''
  return `${BASE_URL}/report-tag-picking-grupo-produto-codigo-barras/${picking_id}?${areaParam}t=${localStorage.getItem('t')}`
}

export function urlReportTagPickingGrupoProdutoCodigoBarrasSingle(pallet_id) {
  return `${BASE_URL}/report-tag-picking-grupo-produto-codigo-barras-single/${pallet_id}?t=${localStorage.getItem('t')}`
}

export function urlReportPickListPorArea(picking_id) {
  return `${BASE_URL}/report-pick-list-area/${picking_id}?t=${localStorage.getItem('t')}`
}

export function urlReportPickListConsolidado(picking_id) {
  return `${BASE_URL}/report-pick-list-consolidado/${picking_id}?t=${localStorage.getItem('t')}`
}

export function urlReportPickListApuracao(picking_id) {
  return `${BASE_URL}/report-pick-list-apuracao/${picking_id}?t=${localStorage.getItem('t')}`
}

// ****** Ordem de Separação ***** //
export function urlReportProdutoPorOrdemSeparacao(picking_id) {
  return `${BASE_URL}/report-produto-por-ordem-separacao/${picking_id}?t=${localStorage.getItem('t')}`
}

// ****** Arquivo de Transferência Pronta Entrega ***** //
export function urlGetInfoParaArquivoTransferenciaProntaEntrega(picking_id) {
  return `${BASE_URL}/arquivo-transferencia-pronta-entrega/${picking_id}`
}

// ****** Associar Area Por Rota de Entrega ***** //
export function urlAssociarAreaDeSeparacaoPorRotaDeEntrega(picking_id) {
  return `${BASE_URL}/associar-area-de-separacao-por-rota-de-entrega/${picking_id}`
}

export function urlAssociarAreaDeSeparacaoPorRotaDeEntregaPorCidade(picking_id) {
  return `${BASE_URL}/associar-area-de-separacao-por-rota-de-entrega-por-cidade/${picking_id}`
}

export function urlAssociarUmClientePorAreaComPlacaPrevista(picking_id) {
  return `${BASE_URL}/associar-um-cliente-por-area-com-placa-prevista/${picking_id}`
}

export function urlAssociarClientesAhRotaDeEntrega() {
  return `${BASE_URL}/associar-clientes-a-rotas-de-entrega`
}

// ************** Picking Mais Opções **************************
export function urlOpenFormularioReconferencia(pickingId) {
  return `${BASE_URL}/formulario-reconferencia/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenResumoSeparacaoAnalitico(pickingId) {
  return `${BASE_URL}/report-resumo-separacao-analitico/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenResumoSeparacaoPorOrigemPDF(pickingId) {
  return `${BASE_URL}/report-resumo-separacao-por-origem/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenResumoSeparacaoPorOrigemEXCEL(pickingId) {
  return `${BASE_URL}/report-resumo-separacao-por-origem-excel/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenListagemDeProdutosConferidosPDF(pickingId) {
  return `${BASE_URL}/report-resumo-separacao-listagem-produtos-conferidos/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenRelacaoPosicoesEstoquePalletArea(pickingId) {
  return `${BASE_URL}/report-relacao-posicoes-estoque-pallet-area/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenFichaRecebimentoCarga(pickingId) {
  return `${BASE_URL}/report-ficha-recebimento-carga/${pickingId}?t=${localStorage.getItem('t')}`
}

export function urlOpenComparativoPickingLoteValidade(pickingId) {
  return `${BASE_URL}/report-comparativo-picking-lote-validade/${pickingId}?t=${localStorage.getItem('t')}`
}

// ************** Associação Area x Cliente **************************
export function urlAssociacaoAreaCliente() {
  return `${BASE_URL}/areas/assoc-area-cliente`
}

// ************** Comparativo do Picking **************************
export function urlGerarComparativoPicking(picking_id, comparativo_type) {
  return `${BASE_URL}/gerar-comparativo-picking/${picking_id}/${comparativo_type}?t=${localStorage.getItem('t')}`
}

export function urlGerarComparativoPickingExcel(picking_id, comparativo_type) {
  return `${BASE_URL}/gerar-comparativo-picking-excel/${picking_id}/${comparativo_type}?t=${localStorage.getItem('t')}`
}

// ************** Gerar Picking a partir das entregas carregadas no veiculo **************************
export function urlGerarPickingAhPartirRoteirizacao() {
  return `${BASE_URL}/gerar-picking-a-partir-roteirizacao`
}

export function urlGerarPickingAhPartirRoteirizacaoClienteEstoque() {
  return `${BASE_URL}/gerar-picking-a-partir-roteirizacao-cliente-estoque`
}

export function urlGerarPickingReconferenciaAhPartirRoteirizacao() {
  return `${BASE_URL}/gerar-picking-reconferencia-a-partir-roteirizacao`
}

export function urlPreviewNomePickingAhPartirRoteirizacao() {
  return `${BASE_URL}/preview-nome-picking-a-partir-roteirizacao`
}

export function urlUploadFotoFalta() {
  return `${DOC_BASE_URL}/falta`
}

export function urlPostFotoFaltaPath(selectedPicking) {
  return `${BASE_URL}/fotos-faltas/${selectedPicking}`
}

export function urlDeleteFotoFalta(filename) {
  return `${DOC_BASE_URL}/falta/${filename}`
}

export function urlFotosFalta(foto_path) {
  return foto_path
}

export function urlUploadFotoSobra() {
  return `${DOC_BASE_URL}/sobra`
}

export function urlDeleteFotoSobra(filename) {
  return `${DOC_BASE_URL}/sobra/${filename}`
}

export function urlFotosSobra(foto_path) {
  return foto_path
}

export function urlPostFotoSobraPath(selectedPicking) {
  return `${BASE_URL}/fotos-sobras/${selectedPicking}`
}

export function urlDeleteMissingProductImage(selectedPicking, id) {
  return `${BASE_URL}/missing-product-foto/${selectedPicking}/${id}`
}
export function urlDeleteLeftoverImage(selectedPicking, id) {
  return `${BASE_URL}/leftover-foto/${selectedPicking}/${id}`
}

// -------------------------
// Rotas específicas para Reconferência
// -------------------------

export const urlPostPutPickingReconferencia = `${BASE_URL}/picking-reconferencia`

export function urlGetPickingsReconferencia(tp_id, picking_status, pInicial, pFinal) {
  return `${BASE_URL}/picks-reconferencia?tp_id=${tp_id}&picking_status=${picking_status}&pInicial=${pInicial}&pFinal=${pFinal}`
}

// -------------------------
// Re-conferência Etiqueta (Pallet Area)
// -------------------------

export function urlGetReconferenciaEtiquetaList(tp_id, dataInicio, dataFim) {
  return `${BASE_URL}/reconferencia-etiqueta/list/${tp_id}?dataInicio=${dataInicio}&dataFim=${dataFim}`
}

export function urlGetReconferenciaEtiquetaDetail(conferencia_id, tp_id) {
  return `${BASE_URL}/reconferencia-etiqueta/detail/${conferencia_id}?tp_id=${tp_id}`
}

export function urlPostReconferenciaEtiquetaCancelar(conferencia_id) {
  return `${BASE_URL}/reconferencia-etiqueta/cancelar/${conferencia_id}`
}

export function urlGetAcompanhamentoItensSeparados(picking_id) {
  return `${BASE_URL}/acompanhamento-itens-separados/${picking_id}`
}

export function urlGetBipsFaltantes(picking_id) {
  return `${BASE_URL}/bips-faltantes/${picking_id}`
}
